import React from "react";

export const GrainOverlay = () => <div aria-hidden="true" className="grain-overlay" />;
